var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.style }, [
    _c("div", { staticClass: "content" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("h3", { staticClass: "title" }, [_vm._v("Oops!")]),
      _vm._v(" "),
      _c("div", { staticClass: "describe" }, [_vm._v(_vm._s(_vm.msg))])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mark" }, [
      _c("img", {
        attrs: {
          width: "197",
          height: "98",
          src: "//img1.jianyewy.com/a93623660fa443e00a6a2fbbf3578635.png",
          alt: "空白"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }